export class GenericoEnum {


    public static getNumberToBoolean = (valor: boolean, classValue: any): number => {
        if (valor  ===  true) {
            return 1;
        }
        return 0;
    };

    public static getDescricaoCompleta = (id: any, classValue: any) => {
        const { label } = GenericoEnum.getObjByValues(id, classValue);
        return label;
    };

    public static getValue = (id: any, classValue: any) => {
        const { value } = GenericoEnum.getObjByValues(id, classValue);
        return value;
    };

    public static getObjByValues(value: any, classValue: any) {
        const idNew = !isNaN(value) ? value : this.getNumberToBoolean(value, classValue);


        for (const key in classValue) {
            if (idNew  ===  classValue[key].value) {
                return classValue[key];
            }
        }


        return classValue[0];
    }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/dominios/enum/generico.enum.ts